import { render, staticRenderFns } from "./ApontamentoProducaoDetalheMateriais.vue?vue&type=template&id=fd40dd7a&"
import script from "./ApontamentoProducaoDetalheMateriais.vue?vue&type=script&lang=js&"
export * from "./ApontamentoProducaoDetalheMateriais.vue?vue&type=script&lang=js&"
import style0 from "./ApontamentoProducaoDetalheMateriais.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports